module.exports = __webpack_public_path__ + "img/nav-wfgl.1a5e6b44.png";